import React from "react";
import EarCareWebsite from "./EarCareWebsite";

function App() {
  return <EarCareWebsite />;
}

export default App;
